import React from 'react'

import './compact-left-sidebar.css'

import { Drawer } from '@mui/material';
import LeftSideBar from '../LeftSideBar';

const LeftSideBarCompact = props => {


  return (
    <div className='compact-sidebar'>
      {/* <button style={{height: '10%'}} onClick={() => handleDrawerOpen()}>
        <ChatBubbleOutline fontSize="large" className='icon' />
      </button> */}
      <Drawer
        open={props.open}
        onClose={() => props.setOpen(false)}
      >
        <div style={{ width: '100%', height: '100%' }}>
          <LeftSideBar isCollapsed={false} onToggleSidebar={() => props.setOpen(false)} />
        </div>
      </Drawer>
    </div>
  )
}

export default LeftSideBarCompact